import React from "react";
import { createPortal } from "react-dom";
import "../assets/styles/components/Modal.scss";
import IconClose from "../assets/static/icons/close.png";

const Modal = (props) =>
  props.isOpen
    ? createPortal(
        <div className="modal">
          <figure onClick={props.onClose} className="modal__close">
            <img className="modal__close-icon" src={IconClose} alt="Close" />
          </figure>
          <div className="modal__container">{props.children}</div>
        </div>,
        document.getElementById("modal")
      )
    : "";

export default Modal;
